exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pg-table-header{display:table-cell;font-family:Montserrat}.pg-table-header .pg-header-label{color:#08c;transition:all .3s ease;cursor:pointer;font-family:Montserrat}.pg-table-header .pg-header-widget{display:none;font-family:Montserrat;color:#f55753}.pg-table-header .pg-header-widget.active{display:block}.pg-table-header .pg-header-widget.active i{font-size:18px;cursor:pointer}.pg-table-header .pg-header-widget.active i:hover{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0f46a83e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/table_header.vue
// module id = 1291
// module chunks = 1